module.exports = __webpack_public_path__ + "static/media/yamada.d2d5a9b1.jpg";